import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-[#0f0f0f] border-t border-white/8 py-20">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div className="space-y-5">
            <img
              src="https://public.readdy.ai/ai/img_res/986c59b2-a2b4-4fd2-b575-bd141709e178.png"
              alt="NOKX GLOBAL LTD"
              className="h-10 w-auto"
            />
            <p className="text-sm text-[#888888] leading-relaxed">
              {t('footer.tagline')}
            </p>
            <div className="flex items-center gap-3 pt-2">
              <div className="w-2 h-2 bg-[#d4af37] rounded-full animate-pulse"></div>
              <p className="text-xs text-[#d4af37] font-medium">
                Accès limité • Places exclusives
              </p>
            </div>
          </div>

          <div className="space-y-4">
            <h4 className="text-sm font-semibold text-white mb-4">
              <a href="#legal">{t('footer.legal')}</a>
            </h4>
            <div className="space-y-3">
              <Link
                to="/mentions-legales"
                className="block text-sm text-[#888888] hover:text-white transition-colors cursor-pointer"
              >
                {t('footer.legalNotice')}
              </Link>
              <a
                href="#"
                rel="nofollow"
                className="block text-sm text-[#888888] hover:text-white transition-colors cursor-pointer"
              >
                {t('footer.terms')}
              </a>
              <a
                href="#"
                rel="nofollow"
                className="block text-sm text-[#888888] hover:text-white transition-colors cursor-pointer"
              >
                {t('footer.privacy')}
              </a>
              <a
                href="#"
                rel="nofollow"
                className="block text-sm text-[#888888] hover:text-white transition-colors cursor-pointer"
              >
                {t('footer.agreement')}
              </a>
            </div>
          </div>

          <div className="space-y-4">
            <h4 className="text-sm font-semibold text-white mb-4">
              <a href="#contact">{t('footer.contact')}</a>
            </h4>
            <div className="space-y-3">
              <a
                href="#"
                className="block text-sm text-[#888888] hover:text-white transition-colors cursor-pointer"
              >
                {t('footer.contactConcierge')}
              </a>
              <a
                href="mailto:contact@robotconcierge.store"
                className="block text-sm text-[#d4af37] hover:text-white transition-colors cursor-pointer"
              >
                contact@robotconcierge.store
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#666666]">
            {t('footer.copyright')}
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            rel="nofollow"
            className="text-xs text-[#555555] hover:text-[#888888] transition-colors cursor-pointer"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
